import { render } from "./OpenNewIncidenceModal.vue?vue&type=template&id=152392c4"
import script from "./OpenNewIncidenceModal.vue?vue&type=script&lang=js"
export * from "./OpenNewIncidenceModal.vue?vue&type=script&lang=js"

import "./OpenNewIncidenceModal.vue?vue&type=style&index=0&id=152392c4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__